import { action } from 'mobx';
import { inject, observer } from 'mobx-react';
import * as React from 'react';

import './activate-email.css';
import PageFrameSingleForm from '../../common/page-frames/single-form';
import Spinner from '../../common/spinner';

import { ActivateEmailStatus, ActivateEmailProps } from '../../types';

@inject('activateEmailStore')
@observer
class ActivateEmail extends React.Component<ActivateEmailProps> {
  @action
  public componentDidMount() {
    const store = this.props.activateEmailStore!;
    switch (store.activateEmailStatus) {
      case ActivateEmailStatus.NOT_STARTED: {
        const { uid, token } = this.props.match.params;
        store.activateEmail(uid, token);
        break;
      }
    }
  }

  public render() {
    const store = this.props.activateEmailStore!;
    let icon;
    let postActivateAction;
    switch (store.activateEmailStatus) {
      case ActivateEmailStatus.ACTIVATED:
        icon = <span className="icon"><i className="fas fa-check" /></span>;
        postActivateAction = { text: 'Sign In', href: '/sign-in' };
        break;
      case ActivateEmailStatus.INVALID:
        icon = <span className="icon"><i className="fas fa-exclamation-triangle" /></span>;
        postActivateAction = { text: 'Resend activation email', href: '#' };
        break;
      default:
        icon = <Spinner />
    }

    let postActivateActionButton;
    if (postActivateAction) {
      postActivateActionButton = (
        <div className="columns is-centered">
          <div className="column is-6">
            <a className="button is-primary post-activate-action" href={postActivateAction.href}>
              {postActivateAction.text}
            </a>
          </div>
        </div>
      )
    }

    return (
      <PageFrameSingleForm
        formTitle="Email activation"
        title="Email activation"
      >

        <div className="container activate-status">
          <div className="columns is-centered">
            <div className="column is-12 has-text-centered">{icon}</div>
          </div>
          <div className="columns is-centered">
            <div className="column is-12 has-text-centered" id="verify-instructions">
              <div className="is-size-5">
                {this.props.activateEmailStore!.instructions}
              </div>
            </div>
          </div>

          { postActivateActionButton }
        </div>
      </PageFrameSingleForm>
    );
  }
}

export default ActivateEmail;



// WEBPACK FOOTER //
// ./src/pages/activate-email/ActivateEmail.tsx